import styled from 'styled-components/macro';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
const TRANSITION_TIME = '0.3s';
export const SegmentPreviewCardTextStyled = styled.span `
  border-bottom: 1px solid transparent;

  transition: all ${TRANSITION_TIME};
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  &:hover ${SegmentPreviewCardTextStyled} {
    border-bottom-color: ${colorCoreBlack900Base};

    transition: all ${TRANSITION_TIME};
  }
`;
